<div class="transport-tile-list">
  <div class="tile-container">

    <ng-container *ngIf="layoutDefinition != null">
      <ng-container *ngFor="let t of transportsForView">
        <div class="tile" (click)="toggleSelection(t)" class="tile"
          [ngClass]="{'selected': selectedTransportId === t.id}">
          <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
            [transport]="t.transportDetails">
          </app-transport-details>
        </div>
        <sc-list-spacer></sc-list-spacer>
      </ng-container>
    </ng-container>


  </div>
  <div class="count-bar">
    <div class="count-bar-layout">
      <div class="count">
        <span class="label">
          {{'total ' | translate: ['tmc.visit.overview.total-count', translationService.language]}}
        </span>
        <span class="value">{{totalCount}}</span>
      </div>

      <div class="count">
        <span class="label">
          {{'planned' | translate: ['tmc.visit.overview.planned-count', translationService.language]}}
        </span>
        <span class="value">{{plannedCount}}</span>
      </div>

      <div class="count">
        <span class="label">
          {{'in progress' | translate: ['tmc.visit.overview.in-progress-count', translationService.language]}}
        </span>
        <span class="value">{{inProgressCount}}</span>
      </div>

      <div class="count">
        <span class="label">
          {{'finished' | translate: ['tmc.visit.overview.finished-count', translationService.language]}}
        </span>
        <span class="value">{{finishedCount}}</span>
      </div>
    </div>
  </div>
</div>